import { Chip } from '@mui/material';

export type RoleStatusChipConfig = {
  backgroundColor: string;
  color: string;
};

type RoleStatusChipProps = {
  label: string;
  config?: RoleStatusChipConfig;
};

const RoleStatusChip = ({ label, config }: RoleStatusChipProps) => (
  <Chip
    size="small"
    label={label}
    sx={{
      height: 24,
      backgroundColor: config?.backgroundColor || 'rgba(97, 97, 97, 0.08)',
      color: config?.color || 'text.secondary',
      fontWeight: 600,
      '& .MuiChip-label': { px: 1 },
    }}
  />
);

export default RoleStatusChip;
